var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5491 1.79917L11.0188 1.26884V1.26884L11.5491 1.79917ZM14.2008 1.79917L14.7311 1.26884V1.26884L14.2008 1.79917ZM14.2008 4.45083L13.6705 3.9205L14.2008 4.45083ZM3.875 14.7766V15.5266C4.07391 15.5266 4.26468 15.4476 4.40533 15.3069L3.875 14.7766ZM1.25 14.7766H0.5C0.5 15.1908 0.835786 15.5266 1.25 15.5266L1.25 14.7766ZM1.25 12.0983L0.71967 11.568C0.579018 11.7086 0.5 11.8994 0.5 12.0983H1.25ZM12.0795 2.3295C12.5188 1.89017 13.2311 1.89017 13.6705 2.3295L14.7311 1.26884C13.706 0.243718 12.0439 0.243718 11.0188 1.26884L12.0795 2.3295ZM13.6705 2.3295C14.1098 2.76884 14.1098 3.48116 13.6705 3.9205L14.7311 4.98116C15.7562 3.95603 15.7562 2.29397 14.7311 1.26884L13.6705 2.3295ZM13.6705 3.9205L3.34467 14.2463L4.40533 15.3069L14.7311 4.98116L13.6705 3.9205ZM3.875 14.0266H1.25V15.5266H3.875V14.0266ZM11.0188 1.26884L0.71967 11.568L1.78033 12.6286L12.0795 2.3295L11.0188 1.26884ZM0.5 12.0983V14.7766H2V12.0983H0.5ZM9.8938 3.4545L12.5455 6.10616L13.6061 5.0455L10.9545 2.39384L9.8938 3.4545Z",
    fill: "#EAA827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconMenu);
export default __webpack_public_path__ + "static/media/edit-icon-menu.c715ea8a3a429f203c50f317052b1179.svg";
export { ForwardRef as ReactComponent };